import { Component, Input, OnInit } from '@angular/core';
import { AntifraudeWarning as AntifraudWarning } from '../../shared/antifraud-warning/antifraud-warning';
import { Router } from '@angular/router';
import { AntifraudWarningService } from './antifraud-warning.service';

@Component({
  selector: 'app-antifraud-warning-screen',
  templateUrl: './antifraud-warning.component.html',
  styleUrls: ['./antifraud-warning.component.styl'],
})
export class AntifraudWarningComponent implements OnInit {
  antifraudData: AntifraudWarning;

  constructor(private antifraudService: AntifraudWarningService, private router: Router) { }

  ngOnInit() {
    this.antifraudData = this.antifraudService.antifraudData;

    if(!this.antifraudData){
      this.router.navigate(['/']);
    }
  }

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/antifraud-warning/antifraud-warning.component.ts